

















































































































import validators from '@/validators';
import { ENDPOINTS, get, post, put } from '@/api/mainApi';
import Vue from 'vue';
import { RequestSession } from '@/interfaces/requestSession';
import { Donation } from '@/interfaces/donation/donation';
import PaymentMethodSelectComponent from '@/components/payment/PaymentMethodSelectComponent.vue';
import { isInvoice, isPayLink } from '@/classes/PaymentMethod';
import { PaymentMethod, Type as PaymentType } from '@/interfaces/economy/paymentMethod';
import { Invoice } from '@/interfaces/economy/invoice';
import DonationAmountComponent from '@/components/payment/DonationAmountComponent.vue';
import TaxReductionInformationComponent from '@/components/TaxReductionInfoComponent.vue';
import { Sms } from '@/interfaces/sms';
import { Snackbar } from '@/interfaces/presentation/snackbar';
import PaylinkErrorRetryComponent from '@/components/payment/PaylinkErrorRetryComponent.vue';
import { SmsType } from '@/enums/smsType';
import { AdminFeeResponse } from '@/interfaces/economy/adminFeeResponse';
import { Intermediary } from '@/interfaces/intermediary/intermediary';

const MobileDetect = require('mobile-detect');

export default Vue.extend({
  name: 'PaymentView',
  components: {
    PaymentMethodSelectComponent,
    DonationAmountComponent,
    TaxReductionInformationComponent,
    PaylinkErrorRetryComponent
  },
  data() {
    return {
      redirecting: false,
      loading: false,
      valid: false,
      failed: false,
      errorText: null,
      rules: validators(this.$t('validation')),
      donationMinAmount: 50,
      donationMaxAmount: 15000,
      invoiceEmail: '',
      mobileNumber: '',
      paymentText: '',
      sms: {
        errorDialog: false,
        errorMessage: '',
        smsValidationWaitTime: 4000
      },
      paymentLoopBreakerThreshold: 10, // used as a breaker incase we get an infinite loop
      numberOfPaymentAttempts: 0,
      adminPercentage: null as number | null,
      amountValue: 0 as number
    };
  },
  computed: {
    isEmailInvoice() {
      return this.donation.paymentSpecification.paymentMethod.type == PaymentType.INVOICE_EMAIL;
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession
    },
    donation(): Donation {
      return this.$store.state.donation
    },
    nextText() {
      if (this.url) {
        return this.$t('payment.open');
      } else {
        return this.$t('payment.pay');
      }
    },
    mobileLabel(): string {
      if (this.donation.paymentSpecification && this.donation.paymentSpecification.paymentMethod && this.donation.paymentSpecification.paymentMethod.type === PaymentType.PAYLINK_SMS) {
        return this.$t('payment.customerMobileForPayLink').toString()
      } else {
        if (this.donation.incomingChannel === 'Bitnet' || this.donation.incomingChannel === 'Bitnet - förmedling') {
          return this.$t('payment.customerMobileForSwish').toString()
        } else {
          return this.$t('payment.yourMobileForSwish').toString()
        }
      }
    },
    isPhoneBased() {
      let md: any = new MobileDetect(window.navigator.userAgent);
      let isMobile = md.mobile() && !md.tablet();

      return this.donation.paymentSpecification && this.donation.paymentSpecification.paymentMethod && this.donation.paymentSpecification.paymentMethod.type === PaymentType.SWISH && !isMobile
        || this.donation.paymentSpecification && this.donation.paymentSpecification.paymentMethod.type === PaymentType.PAYLINK_SMS
    },
    donationAmountValue(): number {
      // If we are using the percentage model, we need to show the original cause amount (admin fee is hidden). The amount cannot be changed here.
      return !!this.adminPercentage && !!this.donation.paymentSpecification.originalCauseAmount
        ? this.donation.paymentSpecification.originalCauseAmount
        : this.donation.paymentSpecification.causeAmount;
    },
  },
  watch: {
    'donation.paymentSpecification.paymentMethod': {
      handler: function (after: PaymentMethod, before: PaymentMethod) {
        if (after && before && after.type !== before.type) {
          this.getAdminFee();
          if (this.isInvoicePayment(after)) {
            let isEmailInvoiceValue = (after.type === PaymentType.INVOICE_EMAIL);
            if (isEmailInvoiceValue) {
              this.invoiceEmail = this.donation.donor.email;
            }
            this.paymentText = this.$t('confirm.invoice');
          } else if (this.isPayLink(after.type)) {
            this.mobileNumber = this.donation.donor.mobileNumber;
            this.paymentText = this.$t('confirm.paylink');
          } else {
            this.paymentText = this.$t('payment.pay');
          }
        }
      },
      deep: true
    },
    donation(val: Donation | null) {
      if (val && val.paymentSpecification) {
        if (this.isInvoicePayment(val.paymentSpecification.paymentMethod)) {
          this.paymentText = this.$t('confirm.invoice');
        } else if (this.isPayLink(val.paymentSpecification.paymentMethod)) {
          this.mobileNumber = val.donor.mobileNumber;
          this.paymentText = this.$t('confirm.paylink');
        } else {
          this.paymentText = this.$t('payment.pay');
        }
        this.getAdminFee();
      }
    },
  },
  created() {
    if (this.donation) {
      this.loading = true;
      try {
        this.getAdminFee();
        if (this.donation.paymentSpecification && this.donation.paymentSpecification.paymentMethod) {
          if (this.isInvoicePayment(this.donation.paymentSpecification.paymentMethod)) {
            this.paymentText = this.$t('confirm.invoice');
          } else if (this.isPayLink(this.donation.paymentSpecification.paymentMethod)) {
            this.mobileNumber = this.donation.donor.mobileNumber;
            this.paymentText = this.$t('confirm.paylink');
          } else {
            this.paymentText = this.$t('payment.pay');
          }
        }
        this.numberOfPaymentAttempts = 0;
      } finally {
        this.loading = false;
      }
    }
  },
  methods: {
    reset() {
      this.$emit('reset');
    },
    goToPaymentMethodSelection() {
      this.sms.errorDialog = false;
    },
    goToSuccessMethodSelection() {
      this.$emit('step', 9);
      this.sms.errorDialog = false;
    },
    isInvoicePayment(paymentMethodType) {
      return isInvoice(paymentMethodType.type);
    },
    isPayLink(paymentMethodType) {
      return isPayLink(paymentMethodType.type);
    },
    validateDonationAmount(value) {
      const donationAmount = parseInt(value);
      const trueDonationAmount = parseFloat(value);
      if (typeof donationAmount != 'number') {
        return this.$t('validation.numeric');
      } else if (!Number.isInteger(trueDonationAmount)) {
        return this.$t('validation.nonInteger');
      } else if (/^\d+\.\d+$/.test(value)) { // if the value is an integer, but of a bad form (e.g. 10.0)
        return this.$t('validation.hasDecimal');
      } else if (this.donationMaxAmount < donationAmount) {
        return this.$t('validation.maxValue', {max: this.donationMaxAmount});
      } else if (donationAmount < this.donationMinAmount) {
        return this.$t('validation.minValue', {min: this.donationMinAmount});
      }

      return true;
    },
    async getAdminFee() {
      if (this.donation) {
        const intermediary: Intermediary | null = this.requestSession.intermediary;
        let deliveryId = this.donation.deliveryMethod ? this.donation.deliveryMethod.id : null
        let data: AdminFeeResponse = await get(ENDPOINTS.DONATION_CAUSES +
          "/" + this.donation.donationCause.id +
          "/" + ENDPOINTS.DONATION_TYPES +
          "/" + this.donation.donationType.id +
          "/" + ENDPOINTS.ADMIN_FEE,
          {
            deliveryMethodId: deliveryId,
            paymentMethodId: this.donation.paymentSpecification.paymentMethod.id,
            intermediaryId: intermediary ? intermediary.id : null
          });
          if (data) {
            if (!!data.adminAmount) {
              this.donation.paymentSpecification.adminAmount = data.adminAmount;
              this.adminPercentage = null;
            } else {
              this.adminPercentage = data.adminPercentage;
              const causeAmountForAdminCalculation: number = !!this.donation.paymentSpecification.originalCauseAmount ? this.donation.paymentSpecification.originalCauseAmount : this.donation.paymentSpecification.causeAmount
              this.donation.paymentSpecification.adminAmount = causeAmountForAdminCalculation * this.adminPercentage;
            }
          }
      }
    },
    t(label) {
      const $te = this.$te.bind(this);
      const $t = this.$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
    goToPayment() {
      this.errorText = null

      if (!this.$refs.form.validate()) {
        // TODO: Break out and reuse for other form steps
        for (var i = 0; i < this.$refs.form.$children.length; i++) {
          const child = this.$refs.form.$children[i];
          if (!child.valid) {
            this.$vuetify.goTo(child, {offset: 100});
          }
        }
        return;
      }

      this.failed = false;
      this.loading = true;

      // alter the payment method
      put(ENDPOINTS.DONATIONS + "/" + this.donation.serialnumber + "/" + ENDPOINTS.PAYMENT_METHODS + "/" + this.donation.paymentSpecification.paymentMethod.id, {}).then(data => {
        // 1. create invoice
        if (isInvoice(this.donation.paymentSpecification.paymentMethod.type)) {

          if (this.invoiceEmail.length > 0) {
            this.donation.donor.invoiceEmail = this.invoiceEmail;
          }

          post(ENDPOINTS.INVOICE, {
            donationId: this.donation.id,
            invoiceEmail: this.invoiceEmail
          }).then((data: Invoice) => {

            // go to success view
            if (data) {
              setTimeout(() => {
                this.$emit('step', 9);
              }, 200)
            }
          }).catch(error => {
            this.loading = false;
            this.failed = true;
            console.error(error)
          }).finally(() => {
            this.loading = false;
          })
        }
        // 2. PAYLINK
        else if (isPayLink(this.donation.paymentSpecification.paymentMethod.type)) {

          this.donation.donor.mobileNumber = this.mobileNumber;

          // send the SMS
          post(ENDPOINTS.SMS + "/" + ENDPOINTS.SEND + "/" + ENDPOINTS.PAY_REQUEST + "?serialNumber=" + this.donation.serialnumber + "&mobileNumber=" + this.mobileNumber, {})

            // If we were able to send it, then check if there is an error
            .then(res => {

              setTimeout(() => {

                get(ENDPOINTS.SMS + "/" + ENDPOINTS.DONATION + "/" + this.donation.serialnumber + "/" + ENDPOINTS.LATEST + "/" + SmsType.PAY_REQUEST)

                  .then((sms: Sms) => {

                    if (sms.errorMessage && sms.errorMessage.length > 0) {

                      let snackbar: Snackbar = {
                        active: true,
                        color: "error",
                        text: this.$t('payLinkSend.messages.payLinkSend.error'),
                        timeout: 10000,
                        action: null
                      };

                      this.sms.errorMessage = sms.errorMessage;
                      this.sms.errorDialog = true;

                      this.$store.commit('setSnackbar', snackbar);
                      this.loading = false;

                    } else {
                      let snackbar: Snackbar = {
                        active: true,
                        color: "success",
                        text: this.$t('payLinkSend.messages.payLinkSend.success'),
                        timeout: 8000,
                        action: null
                      };
                      this.$store.commit('setSnackbar', snackbar);

                      this.$emit('toSuccess');
                      this.sms.errorDialog = false;
                      this.loading = false;
                    }
                  }).catch(err => {
                  let snackbar: Snackbar = {
                    active: true,
                    color: "error",
                    text: this.$t('payLinkSend.messages.payLinkSend.error'),
                    timeout: 10000,
                    action: null
                  };
                  this.$store.commit('setSnackbar', snackbar);
                  this.loading = false;
                  this.sms.errorMessage = this.$t('payLinkSend.messages.payLinkSend.errorCheckPhoneNumber');
                  this.sms.errorDialog = true;
                })
              }, this.sms.smsValidationWaitTime)
            })
            .catch(err => {
              console.log(err);
              let snackbar: Snackbar = {
                active: true,
                color: "error",
                text: this.$t('payLinkSend.messages.payLinkSend.error'),
                timeout: 10000,
                action: null
              };
              this.$store.commit('setSnackbar', snackbar);
              this.loading = false;
              this.sms.errorMessage = this.$t('payLinkSend.messages.payLinkSend.probableErrorCheckPhoneNumber');
              this.sms.errorDialog = true;
            })
        }
        // 3. create digital payment (Default)
        else {
          get(ENDPOINTS.PAYMENTS + "/" + ENDPOINTS.TRANSACTIONS, {
            paymentMethodId: this.donation.paymentSpecification.paymentMethod.id,
            donationId: this.donation.id
          })
            .then(response => {
              // If we get not found or internal server error
              if (response.status && (response.status == 404 || response.status == 500)) {
                // show error
                this.failed = true
              } else {
                // else, if we can redirect -> do it
                if (response.redirectUrl) {
                  location.href = response.redirectUrl;
                } else {
                  if (this.numberOfPaymentAttempts > this.paymentLoopBreakerThreshold) {
                    this.failed = true
                    this.loading = false
                  } else {
                    // otherwise the previous transaction might have failed and we need to create a new one
                    this.numberOfPaymentAttempts++
                    this.goToPayment()
                  }
                }
              }
            })
            .catch(error => {
              console.error(error);
              this.loading = false;
              this.failed = true
            })
        }
      }).catch(error => {
        console.error(error);
        this.loading = false;
        this.failed = true
        if (error.response?.status === 403) // forbidden means we need to show an error to the user
        {
          this.errorText = error.response.data.msg ? error.response.data.msg : null
        }
      })
    },
  },
});
